import { useState } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Process from './components/Process';
import About from './components/About';
import FinalCTA from './components/FinalCTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function Home() {
  const [isNavFixed, setIsNavFixed] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setIsNavFixed(true);
    } else {
      setIsNavFixed(false);
    }
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', handleScroll);
  }

  return (
    <div className="bg-black text-white">
      <Navigation isFixed={isNavFixed} />
      <Hero />
      <Services />
      <Process />
      <About />
      <FinalCTA />
      <Contact />
      <Footer />
    </div>
  );
}
